import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import PaymentBadge from "@molecules/ObjectCard/Attributes/AttributeBadges/PaymentBadge/PaymentBadge"
import { PaymentLevel } from "@molecules/ObjectCard/Attributes/AttributeBadges/PaymentBadge/PaymentBadge.types"

import { DownPaymentBadgeProps } from "./DownPaymentBadge.types"

type DownPaymentStatus = Exclude<EstimateDownPaymentStatus, "Not Required">

const PRESENTATION: Record<
    DownPaymentStatus,
    { level: PaymentLevel; tooltipLabel: string; amountSource: "amount" | "amountDue" }
> = {
    Paid: { level: "full", tooltipLabel: "Paid", amountSource: "amount" },
    "Partially Paid": { level: "partial", tooltipLabel: "Remaining", amountSource: "amountDue" },
    Unpaid: { level: "none", tooltipLabel: "Required", amountSource: "amountDue" },
}

export default function DownPaymentBadge(props: DownPaymentBadgeProps) {
    const { status, amount, amountDue, isOverdue = false, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    if (status === "Not Required") {
        return null
    }

    const presentation = PRESENTATION[status]

    const rawAmount = presentation.amountSource === "amount" ? amount : amountDue
    const formattedAmount = rawAmount != null ? formatCurrency(rawAmount) : null

    const tooltip = formattedAmount ? `${presentation.tooltipLabel}\n${formattedAmount}` : presentation.tooltipLabel

    return (
        <PaymentBadge level={presentation.level} isEscalated={isOverdue} size={size} tooltip={tooltip}>
            Deposit
        </PaymentBadge>
    )
}
